<div class="col-12 col-md-8 float-right p-0" *ngIf="isGraphicLoaded()">
  <p-panel styleClass="mb-3" [toggleable]="true" [collapsed]="false">
    <p-header>
      <i class="fa fas fa-lg fa-file-contract"></i>
      <span class="ml-2">{{ 'DossierBasicInfo.frameworkaggrement.progress.pendAmount' | translate }}</span>
    </p-header>
    <div class="col-12 p-0">
      <!--canvas baseChart #chart class="chart" class="flot-overlay  m-t" [datasets]="chartTopData"
        [labels]="chartTopLabels" [chartType]="chartTopType" [colors]="chartColors" [options]="chartOptions"
        responsive="true" (chartClick)="chartClicked($event)"></canvas-->
      <p-chart #chart (onDataSelect)="chartClicked($event)" responsive="true" type="{{this.chartTopType}}"
        [data]="this.chartTopData" height="40vh" style="left: 16%;" class="p-0 chart-center"></p-chart>
      <span style="position: absolute;top: 35%;left: 30%;font-size: 3em;width: 40%;text-align: center;">{{ totalProgress
        }}</span>
      <span style="position: absolute;top: 55%;left: 30%;width: 40%;text-align: center;">
        <small>{{ 'DossierBasicInfo.frameworkaggrement.progress.pendant' | translate }}</small>
      </span>
    </div>
    <div class="col-12 p-0">
      <ul class="category-list" style="padding-left: 0; ">
        <li *ngIf="isChartShowLot()" class="mt-2 m-b-2 pb-5">
          <button (click)="processChartData()" type="button" class="btn btn-primary btn-sm">
            <i class="fas fa-chevron-left" aria-hidden="true"></i> {{ 'DossierBasicInfo.frameworkaggrement.backAllLots'
            | translate }} </button>
        </li>
        <li *ngIf="!isChartShowLot()"> {{ 'DossierBasicInfo.frameworkaggrement.progress.faAmount' | translate }} </li>
        <li *ngIf="isChartShowLot()"> {{ 'DossierBasicInfo.frameworkaggrement.progress.lotAmount' | translate }} {{
          activeLotDesc }}</li>
        <li *ngFor="let elemento of chartTopLabels; let num = index">
          <a *ngIf="lots.length>1" style="padding: 0px;" (click)="processChartData(lots[num])">
            <i class="fa fa-circle" [style.color]="this.uiService.backgroundColor[num]">
            </i>
            <small>{{ elemento }}: {{ this.chartTopData['datasets'][0].data[num] | number:'1.2-2' }}€</small>
          </a>
          <a *ngIf="lots.length==1" style="padding: 0px;">
            <i class="fa fa-circle" [style.color]="this.uiService.backgroundColor[num]">
            </i>
            <small>{{ elemento }}: {{ this.chartTopData['datasets'][0].data[num] | number:'1.2-2' }}€</small>
          </a>
        </li>
      </ul>
    </div>
  </p-panel>
</div>